import { useQuery } from '@tanstack/react-query'

import axios from 'axios'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

export const STYLE_PRESETS_QUERY_KEY = ['generatorStylePresets']
export const STYLE_PRESETS_ENDPOINT = '/api/internal/generator/style_presets'
const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000

/**
 * @returns {Promise<Array<{ id: number, slug: string, name: string, tags: string[],
 *   image_url: string, asset_id: number }>>}
 */
export async function fetchStylePresets() {
  const { data } = await axios.get(STYLE_PRESETS_ENDPOINT)
  return data?.data ?? EMPTY_ARRAY
}

// The catalogue is public and cached a day server-side, so it is fetched once per
// session and shared by every mount of the panel.
function useStylePresets() {
  const { data, isLoading, isError } = useQuery({
    queryKey: STYLE_PRESETS_QUERY_KEY,
    queryFn: fetchStylePresets,
    staleTime: ONE_DAY_IN_MS,
  })

  return {
    styles: data ?? EMPTY_ARRAY,
    isLoading,
    isError,
  }
}

export default useStylePresets
